import type { IntlShape } from 'react-intl';
import { EmissionCategory, isEmissionCategory } from '@enmon/commons/lib/enmon';
import { isNumber } from '@/utils/isNumber';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const EMISSION_CATEGORY_TRANSLATED = defineMessages<EmissionCategory>({
  [EmissionCategory.BusinessTravel]: {
    id: 'app.common.emissionCategory.businessTravel',
  },
  [EmissionCategory.CapitalGoods]: {
    id: 'app.common.emissionCategory.capitalGoods',
  },
  [EmissionCategory.StationaryCombustion]: {
    id: 'app.common.emissionCategory.stationaryCombustion',
  },
  [EmissionCategory.MobileCombustion]: {
    id: 'app.common.emissionCategory.mobileCombustion',
  },
  [EmissionCategory.EmployeeCommuting]: {
    id: 'app.common.emissionCategory.employeeCommuting',
  },
  [EmissionCategory.EndOfLife]: {
    id: 'app.common.emissionCategory.endOfLife',
  },
  [EmissionCategory.Franchises]: {
    id: 'app.common.emissionCategory.franchises',
  },
  [EmissionCategory.FuelAndEnergy]: {
    id: 'app.common.emissionCategory.fuelAndEnergy',
  },
  [EmissionCategory.Investments]: {
    id: 'app.common.emissionCategory.investments',
  },
  [EmissionCategory.UpstreamLeasedAssets]: {
    id: 'app.common.emissionCategory.upstreamLeasedAssets',
  },
  [EmissionCategory.Processing]: {
    id: 'app.common.emissionCategory.processing',
  },
  [EmissionCategory.PurchasedGoodsAndServices]: {
    id: 'app.common.emissionCategory.purchasedGoodsAndServices',
  },
  [EmissionCategory.PurchasedResourcesForOwnUse]: {
    id: 'app.common.emissionCategory.purchasedResourcesForOwnUse',
  },
  [EmissionCategory.DownstreamTransportationAndDistribution]: {
    id: 'app.common.emissionCategory.downstreamTransportationAndDistribution',
  },
  [EmissionCategory.UseOfSoldProducts]: {
    id: 'app.common.emissionCategory.useOfSoldProducts',
  },
  [EmissionCategory.Waste]: {
    id: 'app.common.emissionCategory.waste',
  },
  [EmissionCategory.DownstreamLeasedAssets]: {
    id: 'app.common.emissionCategory.downstreamLeasedAssets',
  },
  [EmissionCategory.UpstreamTransportationAndDistribution]: {
    id: 'app.common.emissionCategory.upstreamTransportationAndDistribution',
  },
  [EmissionCategory.FugitiveEmissions]: {
    id: 'app.common.emissionCategory.fugitiveEmissions',
  },
  [EmissionCategory.ProcessEmissions]: {
    id: 'app.common.emissionCategory.processEmissions',
  },
});

export const getTranslatedEmissionCategory = (
  key: string | number | undefined,
  intl: IntlShape,
): string | undefined => {
  if (!key) return undefined;
  const numberKey = isNumber(key) ? key : parseInt(key);
  return isEmissionCategory(numberKey) ? intl.formatMessage(EMISSION_CATEGORY_TRANSLATED[numberKey]) : key?.toString();
};
